// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import ModulePreloader from "src/scripts/modules/modulePreloader";
import CustomAnimation from "src/scripts/modules/CustomAnimation";

const modulePreloader = new ModulePreloader();
const animations = new CustomAnimation();

jQuery(document).ready(function () {


  setTimeout(function () {
    modulePreloader.hidePreloaderLogo();
  }, 500);

  setTimeout(function () {
    modulePreloader.hidePreloader();
    animations.init();
  }, 1000);
});
